import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { MenuService } from 'src/app/core/services/menu.service';
import { UserService } from 'src/app/core/services/user.service';
import { Dealer } from 'src/app/shared/models/Dealer.model';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { User } from 'src/app/shared/models/user.model';
import { UserMenuSetupComponent } from './user-menu-setup/user-menu-setup.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserVenueSetupComponent } from './user-venue-setup/user-venue-setup.component';

@Component({
	selector: 'app-user-detail',
	templateUrl: './user-detail.component.html',
	styleUrls: ['../../commandcenter.scss'],
})
export class UserDetailComponent implements OnInit {
	@ViewChild('userProfileComponent') userProfileComponent: UserProfileComponent;
	@ViewChild('userVenueSetupComponent') userVenueSetupComponent: UserVenueSetupComponent;
	@ViewChild('userMenuSetupComponent') userMenuSetupComponent: UserMenuSetupComponent;

	@Input() dealerList: Dealer[];
	@Output() dealerListChange = new EventEmitter<Dealer[]>();

	@Input() venueSelectionsAvailable: any[];
	@Output() venueSelectionsAvailableChange = new EventEmitter<any[]>();

	@Input() user: User;
	@Output() userChange = new EventEmitter<User>();

	@Input() onClose: boolean;
	@Output() onCloseChange = new EventEmitter<boolean>();

	@Output() userDeleteChange = new EventEmitter<string>();

	activeTabIndex: number = 0;

	changesToSave: boolean = false;
	currentUserProfileEdit: boolean = false;
	displayDialog: boolean;

	impersonateUserPrompt: boolean = false;
	impersonateUserPassword: string;

	masterVenueList: any[];

	constructor(
		public app: AppService,
		public userService: UserService,
		private focuslink: FocuslinkService,
		private menuService: MenuService,
		private router: Router
	) {}

	ngOnInit(): void {
		this.displayDialog = true;
		if (this.venueSelectionsAvailable) this.masterVenueList = [...this.venueSelectionsAvailable];

		if (!this.user) {
			this.user = this.userService.user;
			this.currentUserProfileEdit = true;
		}
		if (this.user.dealerKey) {
			this.venueListFilterByDealer(this.user.dealerKey);
		}
	}

	async onSave() {
		this.app.devLog(this.user);
		if (this.user.unsaved) {
			try {
				await this.focuslink.userInvite(this.user);
				this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: '', detail: `${this.user.email} has been invited.` });
			} catch (error) {
				console.log(error);
				this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: '', detail: `Error inviting ${this.user.email}. See log for details.` });
			}
		} else {
			if (this.userVenueSetupComponent) {
				this.userVenueSetupComponent.compileUserSelectedVenues();
			}

			try {
				await this.focuslink.userEdit(this.user);
				this.app.msgSvc.add({
					severity: AppMessageSeverity.GREEN,
					summary: '',
					detail: `${this.user.firstName} ${this.user.lastName} profile updated successfully.`,
				});
			} catch (error) {
				console.log(error);
				this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: '', detail: `Error saving ${this.user.email}. See log for details.}` });
			}
		}
		if (this.currentUserProfileEdit) {
			this.menuService.loadMenuFromApi();
			this.userService.user = this.user;
			this.userService.userSubscription.next(this.userService.user);
			this.userService.localStorage.set('user', this.userService.user);
		}
	}

	onDelete() {
		this.focuslink.userDelete(this.user.key);
		this.userDeleteChange.emit(this.user.key);
		this.onCloseChange.emit(true);
	}

	async impersonateUser() {
		this.app.loading(true);

		try {
			const userPayload = await this.focuslink.userImpersonate(this.userService.userSubscription.value.key, this.impersonateUserPassword, this.user.key);
			await this.userService.logout();
			await this.userService.initUser(userPayload.user, userPayload.token);
			console.log(this.userService.userVenues.value);
			this.router.navigate([this.userService.userSubscription.value.preferences.menuDefault]);
		} catch (error) {
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: '', detail: `${error.error.error}` });
		}
		this.app.loading(false);
	}

	venueListFilterByDealer(dealerKey: string) {
		// if (this.userService.user.role === UserRoleEnum.SUPERADMIN || this.userService.user.role === UserRoleEnum.GOD) {
		// 	this.venueSelectionsAvailable = this.masterVenueList?.filter((i) => i.value === dealerKey);
		// }
	}
}
